export function DurationFilter(){
    return function(elements, duration) {
        const filtered = [];
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].duration == duration) filtered.push(elements[i]);
        }
        return filtered;
        };
}
